function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2375 5109 c-664 -89 -1170 -597 -1266 -1268 -18 -130 -6 -387 26 -541 131 -633 599 -1316 1294 -1892 132 -109 131 -109 297 29 155 129 434 406 565 560 343 402 577 824 673 1212 43 172 51 239 51 436 0 162 -3 205 -23 294 -67 297 -197 537 -407 746 -209 209 -458 345 -743 405 -112 24 -357 34 -467 19z m403 -659 c267 -75 471 -271 564 -540 31 -91 32 -102 33 -245 0 -127 -4 -162 -23 -228 -85 -294 -315 -513 -614 -582 -104 -24 -270 -22 -373 4 -309 81 -535 311 -606 618 -32 138 -24 301 20 433 100 296 340 504 649 560 78 15 268 4 350 -20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2445 4286 c-133 -26 -242 -84 -337 -180 -197 -198 -242 -481 -117 -736 80 -162 244 -293 421 -335 81 -19 215 -19 298 1 175 41 338 171 419 334 92 187 94 383 5 566 -125 257 -413 403 -689 350z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M650 1997 c-19 -7 -34 -16 -33 -21 1 -8 250 -148 1624 -915 l336 -188 664 549 c365 302 673 558 684 569 19 19 17 19 -185 18 l-205 0 -58 -72 c-222 -273 -674 -704 -807 -769 -62 -30 -158 -30 -220 0 -52 25 -227 170 -397 330 -121 113 -303 308 -409 439 l-59 72 -450 0 c-322 0 -460 -4 -485 -12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3450 1359 c-432 -358 -798 -660 -815 -670 -16 -11 -39 -19 -49 -19 -11 0 -360 190 -775 422 -416 232 -883 493 -1039 580 -156 87 -287 158 -292 158 -14 0 -21 -58 -18 -149 l3 -85 1425 -798 1425 -798 225 0 225 0 -420 234 c-231 129 -430 245 -442 256 -26 25 -31 84 -10 111 7 8 365 307 797 663 432 357 798 661 814 676 l29 28 -34 18 c-26 14 -62 19 -149 21 l-115 4 -785 -652z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3892 1195 c-414 -343 -755 -625 -757 -627 -3 -2 223 -132 501 -287 l505 -283 162 4 c158 3 163 4 216 33 56 31 106 88 128 148 13 36 18 1603 5 1623 -4 8 -278 -212 -760 -611z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M461 803 c0 -424 4 -597 12 -620 22 -60 72 -117 128 -148 l54 -30 1139 -3 c627 -1 1138 0 1135 2 -7 7 -158 92 -1299 730 -597 334 -1104 619 -1127 632 l-43 25 1 -588z"
}));
function SvgPlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaces);
export default __webpack_public_path__ + "static/media/places.7d55a068db0f2eb4ff5ec2b12c198589.svg";
export { ForwardRef as ReactComponent };